import React from 'react';
import { Feature } from 'core/enums/features';
import { BaseRoute } from 'core/models/base-routes';

export const LandingRoutes: BaseRoute[] = [
  {
    path: 'signed-out',
    title: 'Signed Out',
    name: 'landing.signedOut',
    feature: Feature.Landing,
    component: React.lazy(() => import('./signed-out/signed-out')),
    hideFromMainMenu: true,
  },
  {
    path: 'join',
    title: 'Join',
    name: 'landing.join',
    feature: Feature.Landing,
    component: React.lazy(() => import('./join-dstv/join-dstv')),
    hideFromMainMenu: true,
  },
  {
    path: '/activate',
    title: 'Customer',
    name: 'customer',
    feature: Feature.Customer,
    component: React.lazy(() => import('./activate/activate')),
    hideFromMainMenu: true,
  }
];